export const PUBLIC_URL = process.env.REACT_APP_PUBLIC_URL || '/';
const useCDN = process.env.REACT_APP_COMMIT_SHA && !(process.env.REACT_APP_IS_SLINGSHOT === 'true');
export const TRANSLATIONS_PATH = `${
  useCDN ? `i18n/${process.env.REACT_APP_COMMIT_SHA.substring(0, 7)}` : 'static/i18n'
}/`;
export const HAPI_URL = 'https://generic.wg.spotify.com/hapi';
export const SP_API_URL = 'https://api.spotify.com';
export const SP_ACCOUNTS_URL = 'https://accounts.spotify.com';
export const SP_EMBED_URL = 'https://embed.spotify.com';
export const SUPPORT_SITE_URL = process.env.REACT_APP_SUPPORT_SITE_URL || 'https://support.spotify.com';
export const SPOTIFYCOM_URL = 'https://www.spotify.com';
export const CONTENTREPORTINGAPI_URL = process.env.REACT_APP_CONTENTREPORTING_API_URL || '';
// For testing locally, you can use site key '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI'
// from <https://developers.google.com/recaptcha/docs/faq#localhost_support>
export const CONTENTREPORTING_GOOGLE_RECAPTCHA_V2_SITE_KEY =
  process.env.CONTENTREPORTING_GOOGLE_RECAPTCHA_V2_SITE_KEY || '6LdMJcUlAAAAAJ7UyLipcxOjCEPsWexL99CcOom9';
export const SUPPORT_EMAIL = 'support@spotify.com';
export const FASTER_EMAIL_VERIFICATION = process.env.NODE_ENV === 'development';
